export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";